<div class="products-listing-responsive p-g-12">
   <div class="p-g-12">

      <p-tabView [activeIndex]="tabIndex" (onChange)="handleTabChange($event)">

         <p-tabPanel [header]='setLabel("allHeaderLabel")'>

            <div class="p-g">

               <div class="p-g-12 p-table-tecfolk-fix">

                  <p-table #dt [value]="products" dataKey="id" styleClass="p-table-customers req-management-table "
                     [rowHover]="true" [rows]="10" [loading]="loading" [paginator]="true" [filterDelay]="0"
                     [globalFilterFields]="['name','country.name','representative.name','status']" [first]="first"
                     (onPage)="onPageChange($event)">

                     <ng-template pTemplate="caption" style="text-align: left">
                        <div class="reportMainFilter">
                           <div class="reportMainFields">
                              <div class="filterFields">
                                 <span class="fieldTitle">{{setLabel("searchByItemNameLabel")}}</span>
                                 <input id="searchProduct" #searchProduct autocomplete="off" pinputtext=""
                                    (keyup)="searchLocal(product.name, 'name')" [(ngModel)]="product.name"
                                    [Placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                                    class="p-inputtext p-corner-all p-state-default p-widget">
                              </div>
                              <div class="reportMainBtn">

                                 <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear"
                                    [disabled]="loading" (click)="clear()">
                                    <i class="pi pi-times"></i></span>
                              </div>
                           </div>

                           <div class="reportMainBtn">
                              <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop"
                                 [disabled]="loading" (click)="clear()"> <i class="pi pi-times"></i></span>

                              <!-- <button pButton type="button"
                                 class="p-g-4 p-md-3 p-lg-2 p-button p-widget p-state-default p-corner-all"
                                 (click)="clear()" style="background-color: rgb(38, 223, 183); " label="Clear Search">
                              </button> -->
                              <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top" routerLink="/product" class="iconClear "
                                 [disabled]="loading"> <i class="pi pi-user-plus icon"></i></span>


                              <!-- <button routerLink="/product" pButton type="button"
                                 class="p-g-4 p-md-2 p-button p-widget p-state-default p-corner-all productListingButtons"
                                 style="background-color: rgb(66, 66, 204);" label="Add New">
                              </button> -->

                              <span [pTooltip]='setLabel("printProductsStockQuantityTooltipLabel")' tooltipPosition="top" [disabled]="loading"
                                 [disabled]="!isData" (click)="printProductsStockQuantity()"><i
                                    class="fa fa-print"></i></span>

                              <!-- <button pButton type="button" label="Print Products Stock Quantity"
                                 (click)="printProductsStockQuantity() "
                                 class="p-g-12 p-md-4 p-lg-3 p-button p-widget p-state-default p-corner-all p-button-success productListingButtons">
                              </button> -->

                           </div>
                        </div>

                     </ng-template>

                     <ng-template pTemplate="header">
                        <tr>
                           <th style="max-width: 90px;">{{setLabel("codeLabel")}}</th>
                           <th style="max-width: 90px;">{{setLabel("imageLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("itemLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("inStockLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("unitLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("dateLabel")}}</th>
                           <th style="max-width: 130px; text-align: center;">{{setLabel("actionLabel")}}</th>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="body" let-rowData>
                        <tr (click)="viewProduct(rowData)" class="p-selectable-row">
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("codeLabel")}}
                              </div>
                              {{rowData.code}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold; display: flex;
                              align-items: center;">{{setLabel("imageLabel")}}</div>
                              <div>
                                 <a (click)="openPhoto(rowData.imagePath)">
                                    <img [alt]="" src="{{rowData.imagePath}}" width="60"
                                       style="vertical-align: middle" />
                                 </a>
                              </div>

                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("nameLabel")}}
                              </div>
                              {{rowData.name}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">
                                 {{setLabel("totalQuantityLabel")}}</div>

                              {{rowData.totalQuantity}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("unitLabel")}}
                              </div>

                              {{rowData.unit}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("dateLabel")}}
                              </div>

                              {{rowData.createdOn | date: 'medium'}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">
                                 {{setLabel("actionLabel")}}</div>
                              <div style="text-align: center !important;">
                                 <button pButton type="button" [pTooltip]='setLabel("deleteProductTooltipLabel")'
                                    tooltipPosition="top" style="margin-right: 5px;"
                                    class="p-button-danger p-button-danger p-button" icon="fa fa-times"
                                    (click)="deleteProduct(rowData)">
                                 </button>
                                 <button pButton type="button" [pTooltip]='setLabel("editProductDetailsTooltipLabel")'
                                    tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="viewProduct(rowData)"
                                    style="margin-right: 5px;">
                                 </button>
                                 <!-- <button pButton type="button" pTooltip="Print Stock Quantity" icon="fa fa-print"
                                 (click)="viewProduct(rowData)" class="p-button-success p-button" style="margin-right: 5px;">
                              </button> -->
                              </div>

                           </td>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="emptymessage" let-columns>
                        <tr style="color: black;">
                           <td>
                              {{setLabel("noRecordFoundLabel")}}
                           </td>
                        </tr>
                     </ng-template>
                  </p-table>
               </div>
            </div>
         </p-tabPanel>

         <p-tabPanel [header]='setLabel("readyToSellHeaderLabel")'>

            <div class="p-g">

               <div class="p-g-12 p-table-tecfolk-fix">

                  <p-table #dt [value]="readyToSellProducts" dataKey="id"
                     styleClass="p-table-customers req-management-table " [rowHover]="true" [rows]="10"
                     [loading]="loading" [paginator]="true" [filterDelay]="0"
                     [globalFilterFields]="['name','country.name','representative.name','status']" [first]="first"
                     (onPage)="onPageChange($event)">

                     <ng-template pTemplate="caption" style="text-align: left">
                        <div class="reportMainFilter">
                           <div class="reportMainFields">
                              <div class="filterFields">
                                 <span class="fieldTitle">{{setLabel("searchByItemNameLabel")}}</span>
                                 <input id="searchProduct" #searchProduct autocomplete="off" pinputtext=""
                                    (keyup)="searchReadytoSell(product.name, 'name')" [(ngModel)]="product.name"
                                    [Placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                                    class="p-inputtext p-corner-all p-state-default p-widget">

                              </div>
                              <div class="reportMainBtn">

                                 <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear"
                                    [disabled]="loading" (click)="clear()">
                                    <i class="pi pi-times"></i></span>
                              </div>
                           </div>
                           <div class="reportMainBtn">
                              <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop"
                                 [disabled]="loading" (click)="clear()"> <i class="pi pi-times"></i></span>
                              <!-- <button pButton type="button"
                                 class="p-g-4 p-md-3 p-lg-2 p-button p-widget p-state-default p-corner-all"
                                 (click)="clear()" style="background-color: rgb(38, 223, 183); " label="Clear Search">
                              </button> -->

                              <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top"
                                 routerLink="/product" class="iconClear " [disabled]="loading"> <i
                                    class="pi pi-user-plus"></i></span>


                              <!-- <button routerLink="/product" pButton type="button"
                                 class="p-g-4 p-md-2 p-button p-widget p-state-default p-corner-all productListingButtons"
                                 style="background-color: rgb(66, 66, 204);" label="Add New">
                              </button> -->

                              <!-- <button pButton type="button" label="Print Products Stock Quantity"
                              (click)="printProductsStockQuantity() "
                              class="p-g-12 p-md-4 p-lg-3 p-button p-widget p-state-default p-corner-all p-button-success productListingButtons">
                           </button> -->
                           </div>
                        </div>

                     </ng-template>

                     <ng-template pTemplate="header">
                        <tr>
                           <th style="max-width: 90px;">{{setLabel("codeLabel")}}</th>
                           <th style="max-width: 90px;">{{setLabel("imageLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("itemLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("inStockLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("unitLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("dateLabel")}}</th>
                           <th style="max-width: 130px; text-align: center;">{{setLabel("actionLabel")}}</th>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="body" let-rowData>
                        <tr (click)="viewProduct(rowData)" class="p-selectable-row">
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("codeLabel")}}
                              </div>
                              {{rowData.code}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold; display: flex;
                              align-items: center;">{{setLabel("imageLabel")}}</div>
                              <div>
                                 <a (click)="openPhoto(rowData.imagePath)">
                                    <img [alt]="" src="{{rowData.imagePath}}" width="60"
                                       style="vertical-align: middle" />
                                 </a>
                              </div>

                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("nameLabel")}}
                              </div>
                              {{rowData.name}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">
                                 {{setLabel("totalQuantityLabel")}}</div>

                              {{rowData.totalQuantity}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("unitLabel")}}
                              </div>

                              {{rowData.unit}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("dateLabel")}}
                              </div>

                              {{rowData.createdOn | date: 'medium'}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">
                                 {{setLabel("actionLabel")}}</div>
                              <div style="text-align: center !important;">
                                 <button pButton type="button" [pTooltip]='setLabel("deleteProductTooltipLabel")'
                                    tooltipPosition="top" style="margin-right: 5px;"
                                    class="p-button-danger p-button-danger p-button" icon="fa fa-times"
                                    (click)="deleteProduct(rowData)">
                                 </button>
                                 <button pButton type="button" [pTooltip]='setLabel("editProductDetailsTooltipLabel")'
                                    tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="viewProduct(rowData)"
                                    style="margin-right: 5px;">
                                 </button>
                                 <!-- <button pButton type="button" pTooltip="Print Stock Quantity" icon="fa fa-print"
                                 (click)="viewProduct(rowData)" class="p-button-success p-button" style="margin-right: 5px;">
                              </button> -->
                              </div>

                           </td>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="emptymessage" let-columns>
                        <tr style="color: black;">
                           <td>
                              {{setLabel("noRecordFoundLabel")}}
                           </td>
                        </tr>
                     </ng-template>
                  </p-table>
               </div>
            </div>
         </p-tabPanel>

         <p-tabPanel [header]='setLabel("ingredientsBasedHeaderLabel")'>

            <div class="p-g">

               <div class="p-g-12 p-table-tecfolk-fix">

                  <p-table #dt [value]="ingredientsBasedProducts" dataKey="id"
                     styleClass="p-table-customers req-management-table " [rowHover]="true" [rows]="10"
                     [loading]="loading" [paginator]="true" [filterDelay]="0"
                     [globalFilterFields]="['name','country.name','representative.name','status']" [first]="first"
                     (onPage)="onPageChange($event)">

                     <ng-template pTemplate="caption" style="text-align: left">
                        <div class="reportMainFilter">
                           <div class="reportMainFields">
                              <div class="filterFields">
                                 <span class="fieldTitle">{{setLabel("searchByItemNameLabel")}}</span>
                                 <input id="searchProduct" #searchProduct autocomplete="off" pinputtext=""
                                    (keyup)="searchIngredientsBased(product.name, 'name')" [(ngModel)]="product.name"
                                    [Placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                                    class="p-inputtext p-corner-all p-state-default p-widget">
                              </div>
                              <div class="reportMainBtn">

                                 <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear"
                                    [disabled]="loading" (click)="clear()"> <i class="pi pi-times"></i></span>
                              </div>
                           </div>
                           <div class="reportMainBtn">
                              <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop"
                                 [disabled]="loading" (click)="clear()"> <i class="pi pi-times"></i></span>
                              <!-- <button pButton type="button"
                                 class="p-g-4 p-md-3 p-lg-2 p-button p-widget p-state-default p-corner-all"
                                 (click)="clear()" style="background-color: rgb(38, 223, 183); " label="Clear Search">
                              </button> -->

                              <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top"
                                 routerLink="/product" class="iconClear " [disabled]="loading"> <i
                                    class="pi pi-user-plus"></i></span>

                              <!-- <button routerLink="/product" pButton type="button"
                                 class="p-g-4 p-md-2 p-button p-widget p-state-default p-corner-all productListingButtons"
                                 style="background-color: rgb(66, 66, 204);" label="Add New">
                              </button> -->

                              <!-- <button pButton type="button" label="Print Products Stock Quantity"
                               (click)="printProductsStockQuantity() "
                                    class="p-g-12 p-md-4 p-lg-3 p-button p-widget p-state-default p-corner-all p-button-success productListingButtons">
                                     </button> -->
                           </div>
                        </div>

                     </ng-template>

                     <ng-template pTemplate="header">
                        <tr>
                           <th style="max-width: 90px;">{{setLabel("codeLabel")}}</th>
                           <th style="max-width: 90px;">{{setLabel("imageLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("itemLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("priceLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("dateLabel")}}</th>
                           <th style="max-width: 130px; text-align: center;">{{setLabel("actionLabel")}}</th>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="body" let-rowData>
                        <tr (click)="viewProduct(rowData)" class="p-selectable-row">
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("codeLabel")}}
                              </div>
                              {{rowData.code}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold; display: flex;
                              align-items: center;">{{setLabel("imageLabel")}}</div>
                              <div>
                                 <a (click)="openPhoto(rowData.imagePath)">
                                    <img [alt]="" src="{{rowData.imagePath}}" width="60"
                                       style="vertical-align: middle" />
                                 </a>
                              </div>

                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("nameLabel")}}
                              </div>
                              {{rowData.name}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">
                                 {{setLabel("priceLabel")}}</div>

                              {{rowData.normalPrice}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("dateLabel")}}
                              </div>

                              {{rowData.createdOn | date: 'medium'}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">
                                 {{setLabel("actionLabel")}}</div>
                              <div style="text-align: center !important;">
                                 <button pButton type="button" [pTooltip]='setLabel("deleteProductTooltipLabel")'
                                    tooltipPosition="top" style="margin-right: 5px;"
                                    class="p-button-danger p-button-danger p-button" icon="fa fa-times"
                                    (click)="deleteProduct(rowData)">
                                 </button>
                                 <button pButton type="button" [pTooltip]='setLabel("editProductDetailsTooltipLabel")'
                                    tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="viewProduct(rowData)"
                                    style="margin-right: 5px;">
                                 </button>
                                 <!-- <button pButton type="button" pTooltip="Print Stock Quantity" icon="fa fa-print"
                                 (click)="viewProduct(rowData)" class="p-button-success p-button" style="margin-right: 5px;">
                              </button> -->
                              </div>

                           </td>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="emptymessage" let-columns>
                        <tr style="color: black;">
                           <td>
                              {{setLabel("noRecordFoundLabel")}}
                           </td>
                        </tr>
                     </ng-template>
                  </p-table>
               </div>
            </div>
         </p-tabPanel>

         <p-tabPanel [header]='setLabel("ingredientsHeaderLabel")'>

            <div class="p-g">

               <div class="p-g-12 p-table-tecfolk-fix">

                  <p-table #dt [value]="ingredientsProducts" dataKey="id"
                     styleClass="p-table-customers req-management-table " [rowHover]="true" [rows]="10"
                     [loading]="loading" [paginator]="true" [filterDelay]="0"
                     [globalFilterFields]="['name','country.name','representative.name','status']" [first]="first"
                     (onPage)="onPageChange($event)">

                     <ng-template pTemplate="caption" style="text-align: left">
                        <div class="reportMainFilter">
                           <div class="reportMainFields">
                              <div class="filterFields">
                                 <span class="fieldTitle">{{setLabel("searchByItemNameLabel")}}</span>
                                 <input id="searchProduct" #searchProduct autocomplete="off" pinputtext=""
                                    (keyup)="searchIngredients(product.name, 'name')" [(ngModel)]="product.name"
                                    [Placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                                    class="p-inputtext p-corner-all p-state-default p-widget">
                              </div>
                              <div class="reportMainBtn">

                                 <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear"
                                    [disabled]="loading" (click)="clear()"> <i class="pi pi-times"></i></span>
                              </div>
                           </div>
                           <div class="reportMainBtn">
                              <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop"
                                 [disabled]="loading" (click)="clear()"> <i class="pi pi-times"></i></span>
                              <!-- <button pButton type="button"
                                 class="p-g-4 p-md-3 p-lg-2 p-button p-widget p-state-default p-corner-all"
                                 (click)="clear()" style="background-color: rgb(38, 223, 183); " label="Clear Search">
                              </button> -->
                              <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top"
                                 routerLink="/product" class="iconClear " [disabled]="loading"> <i
                                    class="pi pi-user-plus"></i></span>
                              <!-- <button routerLink="/product" pButton type="button"
                                 class="p-g-4 p-md-2 p-button p-widget p-state-default p-corner-all productListingButtons"
                                 style="background-color: rgb(66, 66, 204);" label="Add New">
                              </button> -->

                              <!-- <button pButton type="button" label="Print Products Stock Quantity"
                                 (click)="printProductsStockQuantity() "
                                 class="p-g-12 p-md-4 p-lg-3 p-button p-widget p-state-default p-corner-all p-button-success productListingButtons">
                                 </button> -->
                           </div>
                        </div>

                     </ng-template>

                     <ng-template pTemplate="header">
                        <tr>
                           <th style="max-width: 90px;">{{setLabel("codeLabel")}}</th>
                           <th style="max-width: 90px;">{{setLabel("imageLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("itemLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("inStockLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("unitLabel")}}</th>
                           <th style="max-width: 130px;">{{setLabel("dateLabel")}}</th>
                           <th style="max-width: 130px; text-align: center;">{{setLabel("actionLabel")}}</th>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="body" let-rowData>
                        <tr (click)="viewProduct(rowData)" class="p-selectable-row">
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("codeLabel")}}
                              </div>
                              {{rowData.code}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold; display: flex;
                              align-items: center;">{{setLabel("imageLabel")}}</div>
                              <div>
                                 <a (click)="openPhoto(rowData.imagePath)">
                                    <img [alt]="" src="{{rowData.imagePath}}" width="60"
                                       style="vertical-align: middle" />
                                 </a>
                              </div>

                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("nameLabel")}}
                              </div>
                              {{rowData.name}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">
                                 {{setLabel("totalQuantityLabel")}}</div>

                              {{rowData.totalQuantity}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("unitLabel")}}
                              </div>

                              {{rowData.unit}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">{{setLabel("dateLabel")}}
                              </div>

                              {{rowData.createdOn | date: 'medium'}}
                           </td>
                           <td class="products-listing-td">
                              <div class="mobile-label" style="width: 40%; font-weight: bold;">
                                 {{setLabel("actionLabel")}}</div>
                              <div style="text-align: center !important;">
                                 <button pButton type="button" [pTooltip]='setLabel("deleteProductTooltipLabel")'
                                    tooltipPosition="top" style="margin-right: 5px;"
                                    class="p-button-danger p-button-danger p-button" icon="fa fa-times"
                                    (click)="deleteProduct(rowData)">
                                 </button>
                                 <button pButton type="button" [pTooltip]='setLabel("editProductDetailsTooltipLabel")'
                                    tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="viewProduct(rowData)"
                                    style="margin-right: 5px;">
                                 </button>
                                 <!-- <button pButton type="button" pTooltip="Print Stock Quantity" icon="fa fa-print"
                                 (click)="viewProduct(rowData)" class="p-button-success p-button" style="margin-right: 5px;">
                              </button> -->
                              </div>

                           </td>
                        </tr>
                     </ng-template>

                     <ng-template pTemplate="emptymessage" let-columns>
                        <tr style="color: black;">
                           <td>
                              {{setLabel("noRecordFoundLabel")}}
                           </td>
                        </tr>
                     </ng-template>
                  </p-table>
               </div>
            </div>
         </p-tabPanel>
         <!-- <p-tabPanel header="Low Stock Products" >
         </p-tabPanel>

         <p-tabPanel header="Top Sold Products" >

         </p-tabPanel> -->

      </p-tabView>
   </div>

   <div *ngIf="imgPreview" (click)="closePhotoPreview()"
      style="position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999999; display: flex; align-items: center; justify-content: center; background: #000000cf;">
      <svg (click)="closePhotoPreview()"
         style="width: 20px; position: absolute; top: 30px; right: 40px; color: #fff; cursor: pointer;"
         aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
         class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
         <path fill="currentColor"
            d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
         </path>
      </svg>
      <img src="{{imgPreviewImg}}" style="width: 25vw; height: auto;background: #fff;" />
   </div>
</div>

<div id="overallProductsStockPrint" style="display: none;">
   <div class="invoice-box" style="padding: 0px !important; width: 57mm; max-width: 57mm; margin: 0 !important;">
      <div style="width: 57mm;max-width: 57mm;">
         <img
            [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
            alt="Company Logo" style="
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 58%;
    margin-top: 3px;
    margin-bottom: 2px;
" />
         <div style="
    text-align: center;
    font-size: 11px;
    line-height: 14px;
    color: black;
">
            {{ branch.name }}
         </div>
         <div style="
    text-align: center;
    font-size: 11px;
    line-height: 14px;
    color: black;
">
            {{ branch.address }}
         </div>
         <div style="
    text-align: center;
    font-size: 11px;
    line-height: 15px;
    color: black;
">
            {{ branch.phone }}
         </div>

         <table
            style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">

            <thead
               style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
               <tr style="background-color: black;color: white; border: 1px solid black;">
                  <th style="width: 40%; word-break: break-word; font-size: 10px;">{{setLabel("productsLabel")}}</th>
                  <th style="width: 30%; word-break: break-word; font-size: 10px; ">{{setLabel("quantityLabel")}}</th>
               </tr>
            </thead>

            <tbody>
               <span>
                  <tr *ngFor="let item of products">
                     <td style="font-size: 9px;border:1px solid black;text-align: center;">{{item.name}}</td>
                     <td style="font-size: 9px;border:1px solid black;text-align: center;">{{item.totalQuantity}}</td>
                  </tr>
               </span>
            </tbody>
         </table>

         <div
            style="text-align:center; padding-top:6px; font-size:10px; font-weight:bold; color:black; white-space: nowrap;">
            {{setLabel("softwareLabel")}}
         </div>

      </div>
   </div>

</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
   <p style="color: white">{{setLabel("pleaseWaitLabel")}}</p>
</ngx-spinner>